<template>
    <div class="col-md-12 mb-2">
        <b-card>
          <div slot="header">
            <b>RM Approval Page
            </b>
          </div>
          <div class="card-body1">
            <form >
              <div class="form-group row" >
              <div class="col-md-6">
                <label>Shipment Type :</label>

                <b-input-group left="<i class='fa fa-truck'></i>">
                  <Multiselect name='shipmentType' v-model='shipmentType' :options='shipmentTypeList' placeholder='Enter Shipment Type'
                    label='label' track-by='label' @input="fetchDisputeReasons(shipmentType)" style="border: 1px solid #c2cfd6;">

                  </Multiselect>
                </b-input-group>
                <span v-show="errors.has('shipmentType')" class="text-danger">{{ errors.first('shipmentType') }}</span>
              </div>
              <div class="col-md-6">
                <label>Client Name :</label>
                <b-input-group left="<i class='fa fa-user'></i>">
                  <vue-element-loading spinner="mini-spinner" color="#FF6700" />
                  <Multiselect name='client' v-model='client' :options='clientList' placeholder='Select Client' label='label'
                    track-by='label' :multiple="true" :close-on-select="false" style="border: 1px solid #c2cfd6;">

                  </Multiselect>
                </b-input-group>
                <span v-show="errors.has('client')" class="text-danger">Client name is required. </span>
              </div>
            </div>
               <div class="form-group row">
              <div class="col-md-6">
                <label> AWB Number :</label>
                <span style="color: blue; font-size: 13px;">
                  (Note: Use Comma(,) for Multiple AWB Numbers) </span>

                <b-input-group left="<i class='fa  fa-book'></i>">
                  <vue-element-loading spinner="mini-spinner" color="#FF6700" />
                  <b-form-input id="AWB" v-model="awbnumber" name="awbnumber" type="text"></b-form-input>
                </b-input-group>
                <span id="AWB" class="text-danger"></span>
                </b-input-group>
                <span v-show="errors.has('AWB')" class="text-danger">AWB Number is required. </span>
              </div>
              <div class="col-md-6">
                <label>Shipment Value :</label>
                <b-input-group left="<i class='fa  fa-book'></i>">
                  <vue-element-loading spinner="mini-spinner" color="#FF6700" />
                  <select name="operator" v-model="operator" id="operator"
                    v-bind:class="{'form-control': true, 'error': errors.has('operator') }">
                    <option value="">--Select--</option>
                    <option value="1">></option>
                    <option value="2"><</option>
                    <option value="3">=</option>
                  </select>
                  <b-form-input id="octroi_MRP"  v-model="octroi_MRP" name="octroi_MRP" v-validate="'decimal:2'" placeholder='Enter Amount' type="text" v-bind:class="{'form-control': true, 'error': errors.has('detended_days_octroi_MRP') }" ></b-form-input>
                </b-input-group>
                <span v-show="errors.has('octroi_MRP')" class="text-danger">Shipment Value is required & Enter only number. </span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-6">
                  <label>Status:</label>
                  <b-input-group left="<i class='fa fa-map-marker'></i>">
                    <b-form-input id="Status"  :disabled="disableFields" placeholder='WHHandover'>
                    </b-form-input>
                  </b-input-group>
                </div>
              <div class="col-md-6">
                <label>Dispute Type :</label>
                <b-input-group left="<i class='fa fa-group'></i>">
                  <vue-element-loading spinner="mini-spinner" color="#FF6700" />
                  <Multiselect name='disputeType' v-model='disputeType' :options='disputeTypeList'
                    placeholder='Select dispute Status'  label='label' track-by='label'
                    style="border: 1px solid #c2cfd6;">
                  </Multiselect>
                </b-input-group>
                <span v-show="errors.has('disputeStatus')" class="text-danger">dispute status is required. </span>
              </div>
            </div>
             <div class="form-group row">
              <div class="col-md-6">
                <label>Ageing of the Dispute :</label>
                <b-input-group left="<i class='fa  fa-book'></i>">
                  <vue-element-loading spinner="mini-spinner" color="#FF6700" />
                  <select name="daysOperator" v-model="daysOperator" id="daysOperator"
                    v-bind:class="{'form-control': true, 'error': errors.has('daysOperator') }">
                    <option value="">--Select--</option>
                    <option value="1">></option>
                    <option value="2"><</option>
                    <option value="3">=</option>
                  </select>
                  <b-form-input id="numberOfDays" v-model="numberOfDays" name="numberOfDays" v-validate="'decimal:2'" placeholder='Enter number of days' type="text" v-bind:class="{'form-control': true, 'error': errors.has('numberOfDays') }" ></b-form-input>
                </b-input-group>
                <span v-show="errors.has('octroi_MRP')" class="text-danger">number of days is required & Enter only number. </span>
              </div>
              <div class="col-md-6">
                <label>Assignee Name :</label>
                <b-input-group left="<i class='fa fa-group'></i>">
                  <vue-element-loading spinner="mini-spinner" color="#FF6700" />
                  <Multiselect name='assignee' v-model='assignee' :options='assigneeList'
                    placeholder='Select assignee name' label='label' track-by='label'
                    style="border: 1px solid #c2cfd6;">
                  </Multiselect>
                </b-input-group>
                <span v-show="errors.has('assignee')" class="text-danger">Assignee name is required. </span>
              </div>
            </div>
              <div class="card-footer">
                <button class="btn btn-sm btn-success" @click="$emit('searchDeails','',awbnumber,client,shipmentType.id,disputeType.label,daysOperator,numberOfDays,octroi_MRP,operator,assignee.label)" type="button"> Search <i class="fa fa-search"></i></button>
                <button class="btn btn-sm btn-danger" @click="resetForm()" type="reset"><i class="fa fa-refresh"></i>    
                  Reset</button>
                  <i  v-if="vSquareButton" class="fa fa-plus-square-o	fa-3x" style="float:right;" @click="$emit('addDisposeShipment')" ></i>

              </div>
            </form>
          </div>
        </b-card>
      </div>
</template>

<style scoped>
</style>

<style src="./actionComponent.component.scss" scoped lang="scss"></style>

<script>
import Multiselect from "vue-multiselect";
import { fetchClientList, disputeSubReason, fetchExternalDisputeReasons } from '../../services/externalDispute';
import {assignUserList } from '../../services/disputeAssigneeCheck';


export default {
  name: "actionComponent",
  components: {
    Multiselect,
  },
  props: {
    ShipmentDetails: {
      type: Object,
      required: true,
    },
    fieldsAccessData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      val: 0,
      awbnumber: '',
      myStr: '',
      client:'',
      Status:'',
      disputeType:'',
      disputeTypeList:[],
      StatusList:[],
      clientList:[],
      assignee:'',
      assigneeList:[],
      shipmentTypeList: [{id:'DTO', label: 'DTO Shipment'}, {id:'RTO', label:'RTO Shipment'}],
      shipmentType:'',
      showModal: false,
      statusDropdown:false,
      vSquareButton:false,
      disableFields: true,
      operator:'',
      octroi_MRP:'',
      daysOperator:'',
      numberOfDays:'',
      statusDataList: [{
        id: 12,
        label: 'NotifyDisposeDMG'
      }, {
        id: 13,
        label: 'DisposeDMG'
      }],
      ShipmentData: {
      },
    };
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.fetchClient()
    this.fetchAssignUserList()
  },
  watch: {
    fieldsAccessData: [
      {
        handler: "manageAccessInformation",
      },
    ],
  },
  methods: {
  hubDropDown() {
  let hubListData = Object.entries(JSON.parse(localStorage.getItem('hubList')));
  let finalDrop = [];
  hubListData.forEach((ele, i) => {
    finalDrop.push({
      id: ele[0],
      label: ele[1]
    });
  })
  return finalDrop;
},
 fetchAssignUserList(){
      assignUserList({}, this.myStr).then(client => {
        let assignList = [...client.data.data, {"assigneeid" : null, "assingee" : "UnAssignList"}] 
        this.assigneeList = assignList.map(user => ({id: user.assigneeid, label: user.assingee}));      })
    },
fetchDisputeReasons(shipmentType){
      console.log(shipmentType);
      let input = {
        taskType : shipmentType.id,
        disputeRaisedType : "Client"
      }
      fetchExternalDisputeReasons(input, this.myStr).then(reasons => {
        let resonData = reasons.data.ReturnResult;
        this.disputeTypeList = resonData.map((reasons, i) => ({id: i, label: reasons.reason}));
      });
    },
    manageAccessInformation(obj) {
      let accessObject = JSON.parse(JSON.stringify(obj));
      console.log(accessObject.userBucket,"accessObject.userBucket");
      if (accessObject.userBucket === "CLT Page") {
        this.vSquareButton=true
      }
      if (accessObject.userBucket == "DMG Page") {
        this.statusDropdown = true;
      }
    },
     resetForm() {
      this.awbnumber=this.hubList = this.Status= ''; this.isLoading = false;
      this.$validator.reset(); this.errors.clear();
    },
    fetchClient(){
      fetchClientList({}, this.myStr).then(client => {
        console.log(client,"client");
        let clienList = client.data.data;
        this.clientList = clienList.map(client => ({id: client.ClientMasterID, label: client.CompanyName}));  
           })
    },
    createDataObject() {
      console.log("Shipment Data :: ", this.ShipmentData.awbnumber);
      this.$emit();
      
    },
    showImage(filePath) {
      this.img = filePath;
      this.showModal = true;
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/views/B2B components/rmApprovalActionComponent.vue?111e7bcd